import { i18n } from '@lt/localization';
import type { RatingStyle, RatingType } from './types';

export const STYLES_RATING: Record<RatingType, RatingStyle> = {
  bad: {
    text: i18n.t('hotel.reviews.rating.bad'),
    styleString: 'var(--background)',
  },
  goodEnough: {
    text: i18n.t('hotel.reviews.rating.goodEnough'),
    styleString: 'var(--background)',
  },
  good: {
    text: i18n.t('hotel.reviews.rating.good'),
    styleString: 'var(--primary)',
  },
  perfect: {
    text: i18n.t('hotel.reviews.rating.perfect'),
    styleString: 'var(--primary)',
  },
};

// Для тестирования
export const TEST_ID_REVIEW_CARD_CONTENT = 'TEST_ID_REVIEW_CARD_CONTENT';
export const TEST_ID_REVIEW_CARD_PLUS_CONTENT =
  'TEST_ID_REVIEW_CARD_PLUS_CONTENT';
export const TEST_ID_REVIEW_CARD_MINUS_CONTENT =
  'TEST_ID_REVIEW_CARD_MINUS_CONTENT';
export const TEST_ID_REVIEW_CARD_ANSWER = 'TEST_ID_REVIEW_CARD_ANSWER';
